<template>
  <div class="OutriggerEvents">
    <h2>CHIME FRB VLBI Event Triggers</h2>
    <b-container fluid>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <b-row>
        <b-table show-empty
               :items="items"
               :fields="fields"
               :small="smallTable"
               dark
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
      >
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="fetchPlots(row.item, row.index, $event.target)" class="mr-1">
            View Event
          </b-button>
        </template>
      </b-table>
      </b-row>
      <b-row>
      <b-col md="4">
      </b-col>
      <b-col md="4">
      <b-form inline>
        <b-form-group label-cols="4" label="Event Number:" label-for="event">
          <b-form-input label-cols="4" label="Event Number:" id="event" v-model="eventNum"/>
        </b-form-group>
        <b-button size="sm" @click.stop="fetchPlots(undefined, undefined, undefined)" class="mr-1">
          Show Plots
        </b-button>
      </b-form>
      </b-col>
      <b-col md="4">
      </b-col>
    </b-row>
      <h1 v-if="plots !== {}">Showing {{eventNum}}</h1>
      <b-row>
        <b-col md="6">
          <b-col md="12">
          <h2>ARO Data</h2>
          <h4>Clean</h4>
          <b-img-lazy fluid width="500px" v-if="Object.keys(plots).includes('aro_clean')" v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${plots['aro_clean']}`"/>
        </b-col>
          <b-col md="12">
          <h4>Dirty</h4>
          <b-img-lazy fluid width="500px" v-if="Object.keys(plots).includes('aro_raw')" v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${plots['aro_raw']}`"/>
        </b-col>
      </b-col>
        <b-col md="6">
          <h2>CHIME/FRB Data</h2>
          <b-img-lazy fluid width="500px" v-if="Object.keys(plots).includes('chime')" v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${plots['chime']}`"/>
      </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
var fields = [
  {key: 'id', label: 'Event No', sortable: true, 'class': 'text-center'},
  {key: 'ARO_event', label: 'ARO DATA PATH', sortable: true, 'class': 'text-center'},
  {key: 'CHIME_event', label: 'CHIME DATA PATH', sortable: true, 'class': 'text-center'},
  {key: 'PATHFINDER_event', label: 'PATHFINDER DATA PATH', sortable: true, 'class': 'text-center'},
  {key: 'actions', label: 'Actions', 'class': 'text-center'}
]
var previousItem = {}
export default {
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      eventNum: null,
      items: [],
      fields: fields,
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  mounted () {
    // this.refreshToken()
    this.fetchEvents()
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    fetchEvents () {
      var url = 'https://frb.chimenet.ca/frb-master/v1/outriggers/outrigger-datapaths'
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseEvents(response.body)
        })
    },
    parseEvents (events) {
      this.items = []
      for (var i = 0; i < events.length; i++) {
        var item = events[i]
        item['_rowVariant'] = 'danger'
        this.items.push(item)
      }
    },
    fetchPlots (item, index, button) {
      if (item !== undefined) {
        item['_rowVariant'] = 'success'
        this.eventNum = item.id
        this.activeItem = item
        previousItem['_rowVariant'] = 'danger'
        previousItem = item
      }
      var basePath = '/data/chime/intensity/processed/ARO_VLBI/chime_frb_events/'
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.plots = {}
      this.plots['aro_clean'] = basePath + this.eventNum + '_cleaned_downsampled.png'
      this.plots['aro_raw'] = basePath + this.eventNum + '_quicklook.png'
      this.plots['aro_hist'] = basePath + this.eventNum + '_intensity_hist.png'
      var url = 'https://frb.chimenet.ca/frb-master/v1/events/datapaths/' + this.eventNum
      this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          var dataPath = response.body[1]
          this.plots = {}
          this.plots['chime'] = dataPath + '/intensity-dm-pipeline/' + this.eventNum + '_snr_waterfall.png'
          this.plots['aro_clean'] = basePath + this.eventNum + '_cleaned_downsampled.png'
          this.plots['aro_raw'] = basePath + this.eventNum + '_quicklook.png'
          this.plots['aro_hist'] = basePath + this.eventNum + '_intensity_hist.png'
        }, response => {
        })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outriggers/outrigger_events.vue